import wtUtil from '@/utils/wtUtil'

const wtValidator = {
  ValidatorNotBlank: (rule, value, callback) => {
    if (wtUtil.isBlank(value)) {
      callback(new Error(''))
    } else {
      callback()
    }
  },
  ValidatorWtUpload: (rule, value, callback) => {
    if (!value || value.length <= 0) {
      const text = rule.name ? `请上传${rule.name}` : '请上传文件'
      return callback(new Error(text))
    }
    if (rule && value.length > rule.limit) {
      return callback(new Error(`最多上传${rule.limit}个文件`))
    }
    return callback()
  },
  ValidatorWtEditor: (rule, value, callback) => {
    if (wtUtil.isBlank(value)) {
      callback(new Error(''))
    } else {
      callback()
    }
  },
  ValidatorWtImage: (rule, value, callback) => {
    if (value.length === 0) {
      return callback(new Error('商品库存不能为负数'))
    }
    return callback()
  },
  ValidatorPhonePattern: (rule, value, callback) => {
    return /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/
  },
  ValidatorGreaterZeroInt: (rule, value, callback) => {
    if (!wtUtil.isGreaterZeroInt(value)) {
      callback(new Error('请输入不小于0的整数'))
    } else {
      callback()
    }
  },
  ValidatorGreaterZeroFloat: (rule, value, callback) => {
    if (!wtUtil.isGreaterZeroFloat(value)) {
      callback(new Error('请输入不小于0的数'))
    } else {
      callback()
    }
  },
  ValidatorEMax: (rule, value, callback) => {
    if (value * 1 > 999999.999) {
      return callback(new Error('不能大于999999.999'))
    }
    return callback()
  },
  ValidatorMaxIntegral: (rule, value, callback) => {
    if (value * 1 > 999999) {
      return callback(new Error('不能大于999999'))
    }
    return callback()
  },
  ValidatorWeightLength: (rule, value, callback) => {
    if (/\./.test(value) && value.split('.')[1].length > 3) {
      return callback(new Error('小数点后最多只能有3位数'))
    }
    return callback()
  }
}

export default wtValidator
